import {
  IconDownload,
  IconAdFree,
  IconPlayAlt,
  IconShuffle,
  IconGroupSession,
  IconCollaborativePlaylist,
  IconBlend,
} from '@spotify-internal/encore-web';

export const ICON_MAP: Record<string, typeof IconDownload> = {
  download: IconDownload,
  ad_free: IconAdFree,
  play_alt: IconPlayAlt,
  shuffle: IconShuffle,
  group_session: IconGroupSession,
  collaborative_playlist: IconCollaborativePlaylist,
  blend: IconBlend,
};
